module.exports = __webpack_public_path__ + "static/why-hightech-products-drive-us-crazy-and-how-to-restore-the-sanity-f8b308746ede0b38681cfb298364cb77.jpg";